module.exports = __webpack_public_path__ + "static/media/rotate-to-landscape.e663ffb3.gif";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/rotate-to-landscape.gif
// module id = 651
// module chunks = 0